import { checkoutCurrency, pricingFor } from '~/constants/pricing'

/**
 * The price list this visitor buys from: Czech crowns or Polish złoty
 * (Stripe) when they read the site in Czech or Polish and that checkout is
 * on, dollars (LemonSqueezy) otherwise (constants/pricing.ts, checkoutCurrency). Every price on a page
 * comes through here or usePremiumPlans, so what is shown is what is charged.
 */
export function usePricing() {
  const config = useRuntimeConfig()
  const { locale } = useI18n()
  const currency = computed(() => checkoutCurrency(locale.value, config.public.stripeCzk, config.public.stripePln))
  const pricing = computed(() => pricingFor(currency.value))
  return { currency, pricing }
}
